import React, { useState } from 'react';
import { MessageBoxSpace } from 'src/components/general';

type Props = {
  isOver: boolean;
  isUnder: boolean;
  isEqual: boolean;
};

const BeneficiaryAlerts = ({
  isEqual,
  isOver,
  isUnder,
}: Props): JSX.Element => {
  const [showInfo, setShowInfo] = useState(true);
  const [showSuccess, setShowSuccess] = useState(true);
  const [showError, setShowError] = useState(true);

  return (
    <>
      {isUnder && showInfo && (
        <MessageBoxSpace
          data-testid="info-alert"
          message="Tienes porcentaje de beneficiarios pendiente de asignar. Completa el 100% para continuar."
          variant="info"
          onCloseClick={(): void => {
            setShowInfo(false);
          }}
        />
      )}
      {isEqual && showSuccess && (
        <MessageBoxSpace
          data-testid="success-alert"
          message="El 100% del porcentaje ha sigo asignado. Selecciona guardar para continuar."
          variant="success"
          onCloseClick={(): void => {
            setShowSuccess(false);
          }}
        />
      )}
      {isOver && showError && (
        <MessageBoxSpace
          data-testid="error-alert"
          message="Tienes porcentaje de beneficiarios superior al 100%. Ajuste el porcentaje para continuar."
          variant="error"
          onCloseClick={(): void => {
            setShowError(false);
          }}
        />
      )}
    </>
  );
};

export default BeneficiaryAlerts;
